function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.672 7L7.379 2.707l1.414-1.414L15.5 8l-6.707 6.707-1.414-1.414L11.672 9H1.5V7h10.172z",
  fill: "currentColor"
});

var SvgNextStoryPointer = function SvgNextStoryPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTEuNjcxNyA3TDcuMzc4OTEgMi43MDcxOEw4Ljc5MzEyIDEuMjkyOTdMMTUuNTAwMiA4LjAwMDA4TDguNzkzMTIgMTQuNzA3Mkw3LjM3ODkxIDEzLjI5M0wxMS42NzE5IDlIMS41VjdMMTEuNjcxNyA3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjwvZz4KPC9zdmc+Cg==";
export { SvgNextStoryPointer as ReactComponent };